module.exports = __webpack_public_path__ + "img/IncredEvent-Logo.b65c8750.webp";